export default __webpack_public_path__ + "static/media/CW__3252.99ad4453.jpg";